import { createSlice } from "@reduxjs/toolkit"


const initialState = {
    mobileResponse: "",
    deviceType: "",
    loadingMobile: "idle",
    flagMobile: null,
    responseTitleMobile: null,
    responseDescriptionMobile: null,
    errorMobile: null,
    infoMobile: {},
    isPopupMobile: false,
    payrollsOverviewMobile: [],
    isApproveAll: false
}


const appMobileSlice = createSlice({
    name: "appData",
    initialState,
    reducers: {
        setMobileResponse: (state, action) => {
            state.mobileResponse = action.payload;
        },
        setDeviceType: (state, action) => {
            state.deviceType = action.payload;
        },
        setFlagMobile: (state, action) => {
            state.flagMobile = action.payload;
        },
        setResponseTitleMobile: (state, action) => {
            state.responseTitleMobile = action.payload;
        },
        setResponseDescriptionMobile: (state, action) => {
            state.responseDescriptionMobile = action.payload;
        },
        setErrorMobile: (state, action) => {
            state.errorMobile = action.payload;
        },
        setIsPopupMobile: (state, action) => {
            state.isPopupMobile = action.payload;
        },
        setInfoMobile: (state, action) => {
            state.infoMobile = action.payload;
        },
        setLoadingMobile: (state, action) => {
            state.loadingMobile = action.payload;
        },
        setPayrollsOverviewMobile: (state, action) => {
            state.payrollsOverviewMobile = action.payload;
        },
        setIsApproveAll: (state, action) => {
            state.isApproveAll = action.payload;
        }
    }
})

export const { 
                setMobileResponse, 
                setDeviceType, 
                setFlagMobile, 
                setResponseTitleMobile, 
                setResponseDescriptionMobile,
                setErrorMobile,
                setIsPopupMobile,
                setInfoMobile,
                setLoadingMobile,
                setPayrollsOverviewMobile,
                setIsApproveAll
             } = appMobileSlice.actions;

export default appMobileSlice.reducer;